export default "__VITE_ASSET__70322052__"